"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * BKDR Hash (modified version)
 *
 * @param {String} str string to hash
 * @returns {Number}
 */
function BKDRHash(str) {
    var seed = 131;
    var seed2 = 137;
    var hash = 0;
    // make hash more sensitive for short string like 'a', 'b', 'c'
    str += "x";
    var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER / seed2;
    for (var i = 0; i < str.length; i++) {
        if (hash > MAX_SAFE_INTEGER) {
            hash = Math.floor(hash / seed2);
        }
        hash = hash * seed + str.charCodeAt(i);
    }
    return hash;
}
exports.BKDRHash = BKDRHash;
//# sourceMappingURL=bkdr-hash.js.map